// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2CgsD","modalFooterButton":"ModalNotes_modalFooterButton__2rJtK"};